import PropTypes from "prop-types";
import React from "react";
import { SelectableMenuItem } from "./SelectableMenuItem";
import { useSelector } from "react-redux";
import { UserContextSelectors } from "../../redux/selectors";
import { DataUtils } from "../../utils";

export const SportCategoryMenuItem = ({ item, ...restProps }) => {
  const isAuthenticated = useSelector(UserContextSelectors.isAuthenticated);
  const favouriteSportsEnabled = DataUtils.getDataStoreValue(
    "FavouriteSportsEnabled"
  );
  return (
    <SelectableMenuItem
      item={item}
      hasFavouriteFeature={favouriteSportsEnabled && isAuthenticated}
      isSportCategory={true}
      {...restProps}
    />
  );
};

SportCategoryMenuItem.propTypes = {
  item: PropTypes.object,
  hasFavouriteFeature: PropTypes.bool
};
